import { DiscountType } from './discount-type';

export default class OrderDiscount { 
    Id: number = 0;
    Name: string = '';
    Description: string = '';
    DiscountType?: DiscountType;
    Sum: number = 0;
}